// @flow

import { type AppValues } from '@tectonics/app-values';
import { type IncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { threeDSecure } from './threedsecure';
import { ThreeDSecureError } from './threedsecure-error';

export async function threeDSecureOutgoingPaymentMapper(
  userInputValues: UserInputValues,
  incomingPayment: IncomingPayment,
  appValues: AppValues,
  outgoingPayment: $Shape<OutgoingPayment>,
): Promise<$Shape<OutgoingPayment>> {
  const selectedPaymentMethod = userInputValues['selectedPaymentMethod'];
  const country = getCountry(incomingPayment);

  if (selectedPaymentMethod !== 'debitcard' || country !== 'br') {
    return outgoingPayment;
  }

  try {
    const threeDSecureResponse = await threeDSecure(userInputValues, incomingPayment);

    return {
      card: Object.assign({}, outgoingPayment.card, threeDSecureResponse),
    };
  } catch (ex) {
    throw new ThreeDSecureError('Ops, houve um erro com o seu pagamento :( Conclua o pagamento utilizando outro cartão ou método.');
  }
}
